import angular from 'angular';
import ngMessages from 'angular-messages';
import uiBootstrapModal from 'angular-ui-bootstrap/src/modal';
import uibDatepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup';
import nwngResources from '../resources/ng-resources-service';
import nwConstants from '../../nw-constants';
import mNumEdit from '../m-numedit';
import TaTiliValintaCtrl from './ta-tilivalinta-controller';
import ConfirmModalCtrl from './confirm-controller';
import PagedFilter from './m-paged-filter';
import DpUibDirective from './ma-datepicker-uib';
import ClickedDisableDirective from './clicked-disable-directive';
import mwJquery from '../mw-jquery';
import { maEditTextComponent } from './ma-edit-text-component';
import { maEditNumberComponent } from './ma-edit-number-component';
import { maEditDateComponent } from './ma-edit-date-component';
import { maTextInputDialogComponent } from './ma-text-input-dialog-component';
const mod = angular.module('nw.ui', [
    ngMessages,
    uiBootstrapModal,
    uibDatepickerPopup,
    nwConstants,
    mNumEdit,
    nwngResources,
    mwJquery
] // required at least for clicked-disable directive
)
    .filter('mPaged', PagedFilter)
    .directive('maDatepicker', DpUibDirective)
    .directive('clickedDisable', ClickedDisableDirective)
    .component('maEditDate', maEditDateComponent)
    .component('maEditNumber', maEditNumberComponent)
    .component('maEditText', maEditTextComponent)
    .component('maTextInputDialog', maTextInputDialogComponent);
;
export default mod.name;
mod.factory('NwUi', ['$uibModal', 'Constants', function ($uibModal, Constants) {
        var result = {
            // Select bookkeeping account from accounts which are selectable for entry
            // argument is a function that gets called with the selected account
            TaTiliValintaDialog: function (onSelect) {
                $uibModal.open({
                    template: require('./modal-ta-tilivalinta.tpl.html'),
                    controller: TaTiliValintaCtrl,
                    controllerAs: 'vm',
                    size: 'lg'
                })
                    .result.then(function (tili) {
                    if (onSelect) {
                        onSelect(tili);
                    }
                }, function () { });
            },
            // Näyttää dialogin jossa kysytään vahvistus jollekin 'vaaralliselle'
            // kysymys voi olla suora teksti tai käännöksissä olevan merkkijonon tunnus (ajetaan translate filterin läpi)
            varmistusDangerDialog: function (kysymys, onOk, onCancel) {
                $uibModal.open({
                    template: require('./modal-confirm.tpl.html'),
                    controller: ConfirmModalCtrl,
                    controllerAs: '$ctrl',
                    size: 'sm',
                    resolve: {
                        message: function () {
                            return kysymys;
                        }
                    }
                })
                    .result.then(function () {
                    // tänne tullaan ok napista, tehdään käyttäjän antama toiminto
                    if (onOk) {
                        onOk();
                    }
                }, function () {
                    // tänne tullaan jos vain suljettiin, ei tarvitse tehdä mitään
                    if (onCancel) {
                        onCancel();
                    }
                });
            },
            // Dialogi jossa pyydetään tekstiä
            textInputDialog: function (args) {
                $uibModal.open({
                    component: 'maTextInputDialog',
                    resolve: {
                        args,
                    },
                })
                    .result.then(function (result) {
                    // tänne tullaan ok napista
                    if (args.onOk) {
                        args.onOk(result);
                    }
                }, function () {
                    // tänne tullaan peruuta napista/ruksista
                    if (args.onCancel) {
                        args.onCancel();
                    }
                });
            } // end textInputDialog
        };
        // Varaudaan siihen että tallentamattomille muutoksille on eri dialogi
        result.varmistusDirtyDlg = result.varmistusDangerDialog;
        return result;
    }]);
